// =====================================================
// S-SMS-OTP — phone-verification status signal.
//
// Tiny pub/sub store (mirrors two-factor-gate.js) so AppShell's global
// reminder banner, the Settings phone field, and the /verify-phone page can
// all read/update ONE shared truth without prop-drilling or a context
// provider. `null` = not fetched yet (don't render anything either way),
// `true`/`false` = known.
// =====================================================

let verified = null;
const listeners = new Set();

const emit = () => {
  for (const fn of listeners) {
    try {
      fn(verified);
    } catch {
      // a listener error must not break siblings
    }
  }
};

export const phoneVerifyStatus = {
  get: () => verified,

  set: (v) => {
    const next = !!v;
    if (verified === next) return;
    verified = next;
    emit();
  },

  /** Called on logout so a next different session never inherits stale state. */
  reset: () => {
    if (verified === null) return;
    verified = null;
    emit();
  },

  subscribe: (fn) => {
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  },
};
